const baseURL = process.env.REACT_APP_BASE_URL;

// Fetch Citation Court
export const fetchNeutralCourtSuggestions = async (prefix, year) => {
    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const apiUrl = `${baseURL}/quick-search/neutral-citation-court-suggestion?size=50`;
    const payload = { prefix, year };

    try {
        const response = await axios.post(apiUrl, payload, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data || [];
    } catch (error) {
        console.error("❌ Error fetching neutral court suggestions:", error);
        return [];
    }
};

// Fetch Citation Year
export const fetchNeutralYearSuggestions = async (prefix) => {

    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const apiUrl = `${baseURL}/quick-search/neutral-citation-year-suggestion?size=50`;
    const payload = { prefix };

    try {
        const response = await axios.post(
            apiUrl,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        return response.data || [];
    } catch (error) {
        console.error("❌ Error fetching neutral year suggestions:", error);
        return [];
    }
};

// Fetch NC-Abbr
export const fetchNeutralAbbrSuggestions = async (prefix, neutralYear, neutralCourt) => {

    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const apiUrl = `${baseURL}/quick-search/neutral-citation-nc-abvr-suggestion?size=50`;
    const payload = {
        prefix,
        year: neutralYear,
        court: neutralCourt,
    };

    console.log("Nuetral ABBR Payload", payload);
    console.log("Nuetral ABBR API URL", apiUrl);

    try {
        const response = await axios.post(apiUrl, payload, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data || [];
    } catch (error) {
        console.error("❌ Error fetching neutral abbreviation suggestions:", error);
        return [];
    }
};

// Fetch Citation Page
export const fetchNeutralPageSuggestions = async (prefix, neutralYear, neutralCourt, neutralAbbr) => {

    const token = localStorage.getItem("token") || "";
    const axios = (await import("axios")).default;

    const apiUrl = `${baseURL}/quick-search/neutral-citation-page-suggestion?size=50`;

    const payload = {
        prefix,
        ...(neutralYear && { year: neutralYear }),
        ...(neutralCourt && { court: neutralCourt }),
        ...(neutralAbbr && { abbr: neutralAbbr }),
    };

    try {
        const response = await axios.post(apiUrl, payload, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        });
        return response.data || [];
    } catch (error) {
        console.error("❌ Error fetching neutral page suggestions:", error);
        return [];
    }
};